var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-simple-checkbox',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"small-checkbox",on:{"input":function($event){return _vm.onInput()}},model:{value:(_vm.mnt),callback:function ($$v) {_vm.mnt=$$v},expression:"mnt"}})}
var staticRenderFns = []

export { render, staticRenderFns }